import { Link } from 'react-router-dom';
import { findGame, type CatalogEntry } from '../games/catalog';

/** A small row of game covers with names, linking to each game. Used in articles and What's New. */
export function GameLinks({ ids }: { ids: string[] }) {
  const games = ids.map((id) => findGame(id)).filter((g): g is CatalogEntry => !!g);
  if (!games.length) return null;
  return (
    <ul className="game-links">
      {games.map((g) => (
        <li key={g.id}>
          <Link to={g.path}>
            {g.thumb && <img src={g.thumb.replace('/covers/', '/covers-sm/')} alt="" width={160} height={120} loading="lazy" />}
            <span>{g.name}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
